import AreaContainer from "../AreaContainer";
import AgentsList from "./AgentsList";
import UpgradeProperty from "../UpgradeProperty";
import LocalAgents from "./LocalAgents";
import styles from './agents.module.css';

interface Props {
  sponsored: boolean;
  isLDC: boolean;
  owners: any;
  agents: any;
  centre_managers: any;
  asset_managers: any;
  id: any;
  name: string;
  docType: string;
  local_agents: any;
  title: string;
  isLoggedIn: boolean;
  unfilteredAgents: any;
  payingClient: boolean;
  contactable: boolean;
  bid: boolean
  showAllAgentContacts: boolean;
  setShowAllAgentContacts: any;
  showPage: boolean;
  property: object;
  dxStats: number;
}
const Agents = ({ property, dxStats, setShowAllAgentContacts, showAllAgentContacts, agents = [], owners = [], centre_managers = [], asset_managers = [], sponsored = false, isLDC = false, id, name, docType, local_agents, title, isLoggedIn, unfilteredAgents, payingClient, contactable, bid, showPage }: Props) => {

  let noContacts = agents.length == 0;

  let agentsContactable = !contactable && !bid && !sponsored && !payingClient;
  return (
    <AreaContainer area="agents" style={null} extraClass={styles.stickyContainer}>
      <div className={styles.AgentDetailsContainer}>
        {agents && agents.length > 0 && <AgentsList contactType={'agent'} isLoggedIn={isLoggedIn} property={property} showAllAgentContacts={showAllAgentContacts} agents={agents} contactable={!agentsContactable} sponsored={sponsored} id={id} type={docType} display="agents" title={"Marketed by"}/>}
      </div>
      {noContacts && (local_agents && local_agents.length === 0) && (unfilteredAgents && unfilteredAgents.length === 0) && <UpgradeProperty type={docType} id={id} name={name} noContacts={true} />}
      {noContacts && ((local_agents && local_agents.length > 0) || (unfilteredAgents && unfilteredAgents.length > 0)) && <LocalAgents dxStats={dxStats} property={property} unfilteredAgents={unfilteredAgents} agents={local_agents} id={id}  isLoggedIn={isLoggedIn} payingClient={payingClient} type={docType} showPage={showPage} />}
    </AreaContainer>
  );
};

export default Agents;
